import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';
import { CONSTANTS } from 'src/app/constants';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-hourly-sales',
  templateUrl: './hourly-sales.component.html',
  styleUrls: ['./hourly-sales.component.css']
})
export class HourlySalesComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }
  @Output() errorEmitter = new EventEmitter();

  topTooltipExcel: string = 'Download .xlsx';

  loading: boolean = true;
  viewType: string = 'value';
  viewOptions: any[] = [
    { label: 'Valor', value: 'value' },
    { label: 'Quantidade', value: 'quantity' }
  ];
  originalData: any[] = [];
  dataSource = {
    chart: {
      legendposition: "Right",
      drawanchors: "1",
      showvalues: "0",
      theme: "gammel"
    },
    data: [
      {
        label: '',
        value: ''
      },
    ]
  };
  dateFirst!: any;
  errorApi = false;
  message : string = "";

  constructor(private api: ApiService) {}

  ngOnInit() {
  }

  onViewTypeChange(newType: string) {
    this.viewType = newType;
    this.updateChartData();
  }

  updateChartData() {
    this.dataSource.data = [];
    this.originalData.forEach((item: any) => {
      if (this.viewType === 'value') {
        this.dataSource.data.push({'label': item.hour + 'h', 'value': item.value.toString()});
      } else {
        this.dataSource.data.push({'label': item.hour + 'h', 'value': item.quantity.toString()});
      }
    });
  }

  filterItem(item: any) {
    this.errorApi = false;
    this.loading = true;
    if (item.branch != undefined) {
      this.saleInformation(item).subscribe(data => {
        try {
          this.dataSource.data = [];
          this.originalData = [];
          let excelInfo = [];
          if (data.dataRow.length != 0) {
            data.dataRow.map((el:any) => {
              this.originalData.push({
                hour: el.saledatetime_hour.toString(),
                value: el.invoice_value,
                quantity: el.invoice_qty || 0
              });
              
              if (this.viewType === 'value') {
                this.dataSource.data.push({'label': el.saledatetime_hour.toString()  + 'h', 'value': el.invoice_value.toString()});
              } else {
                const quantity = el.invoice_qty || 0;
                this.dataSource.data.push({'label': el.saledatetime_hour.toString()  + 'h', 'value': quantity.toString()});
              }
              
              excelInfo.push({
                'Data Inicial': item.dataMin, 
                'Data Final': item.dataMax, 
                'Código Filiais': item.branch.toString(), 
                'Hora': el.saledatetime_hour.toString()  + 'h', 
                'Valor': 'R$' + el.invoice_value.toString(),
                'Quantidade': (el.invoice_qty || 0).toString()
              });
            })
            excelInfo.unshift({});
            localStorage.setItem('hourly-sales', JSON.stringify(excelInfo));
            this.errorApi = false;
          } else {
            this.message = CONSTANTS.MESSAGES.DATA_NULL_HOURLY_SALES;
            this.formatErrorMensagem(this.message);
            this.errorApi = true;
          }
          this.loading = false;
        } catch(error: unknown) {
          this.loading = false;
          if (error instanceof Error)
            this.formatErrorMensagem(error.message);
        }
      }, error => {
        this.loading = false;
        this.errorApi = true;
        this.message = CONSTANTS.MESSAGES.DATA_ERRO_HOURLY_SALES;
        this.formatErrorMensagem(error.message);
      });
    }
  }

  downloadExcel() {
    const EXCEL_TYPE =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    let dataHourlySales = [];
    let objectHourlySales = localStorage.getItem('hourly-sales');

    objectHourlySales != null
      ? (dataHourlySales = JSON.parse(objectHourlySales))
      : (dataHourlySales = []);
    const worksheetHourlySales= XLSX.utils.json_to_sheet(dataHourlySales);

    const workbook = {
      Sheets: {
        'vendas-por-hora': worksheetHourlySales,
      },
      SheetNames: [
        'vendas-por-hora',
      ],
    };
    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'buffer',
    });
    const data: Blob = new Blob([excelBuffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(data, 'minhas-operacoes-vendas-por-hora' + EXCEL_EXTENSION);
  }

  saleInformation(item: any): Observable<any> {
    return this.api.postHourSale(item.dataMin, item.dataMax, item.branch, item.sellers)
  }

  formatErrorMensagem(item: any) {
    let dataError = new Date();
    let errorMensagem = "Arquivo: hourly-sales \r\n" + "Data: " + dataError + "\r\n" + "Mensagem: " + item + "\r\n" + "===============================================" + "\r\n";
    this.errorEmitter.emit(errorMensagem);
  }
}
